import React, { useState, useRef, useEffect } from "react";
import { CalendarPlus, ChevronDown } from "lucide-react";

const EVENT = {
  title: "Vernetta & Quin's Wedding",
  details: "The wedding celebration of Vernetta Jenkins and Quintorious \u201cQuin\u201d Bivins. Guest arrival at 3:30 p.m., ceremony at 4:00 p.m.",
  location: "The Metropolitan Club, 5895 Windward Parkway, Alpharetta, GA 30005",
  // 3:30 p.m. EST (UTC-5) Feb 20 2027 -> 20:30 UTC ; ends 10:00 p.m. EST -> 03:00 UTC Feb 21
  startUTC: "20270220T203000Z",
  endUTC: "20270221T030000Z",
};

function googleUrl() {
  const p = new URLSearchParams({
    action: "TEMPLATE",
    text: EVENT.title,
    dates: `${EVENT.startUTC}/${EVENT.endUTC}`,
    details: EVENT.details,
    location: EVENT.location,
  });
  return `https://calendar.google.com/calendar/render?${p.toString()}`;
}

function downloadIcs() {
  const ics = [
    "BEGIN:VCALENDAR", "VERSION:2.0", "PRODID:-//VQ Wedding//EN",
    "BEGIN:VEVENT", `UID:vq-wedding-2027@metropolitanclub`,
    `DTSTAMP:${EVENT.startUTC}`, `DTSTART:${EVENT.startUTC}`, `DTEND:${EVENT.endUTC}`,
    `SUMMARY:${EVENT.title}`, `DESCRIPTION:${EVENT.details}`, `LOCATION:${EVENT.location}`,
    "END:VEVENT", "END:VCALENDAR",
  ].join("\r\n");
  const blob = new Blob([ics], { type: "text/calendar;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url; a.download = "vernetta-quin-wedding.ics"; a.click();
  URL.revokeObjectURL(url);
}

export function AddToCalendar() {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);
  return (
    <div className="relative inline-block" ref={ref}>
      <button onClick={() => setOpen((v) => !v)}
        className="rounded-full px-7 py-3 overline inline-flex items-center gap-2 border border-gold text-gold hover:bg-gold hover:text-matte transition-colors"
        aria-haspopup="true" aria-expanded={open} data-testid="add-to-calendar-btn">
        <CalendarPlus size={16} /> Add to Calendar <ChevronDown size={14} />
      </button>
      {open && (
        <div className="absolute left-1/2 -translate-x-1/2 mt-2 w-52 bg-soft-white border border-taupe/40 rounded-lg overflow-hidden z-20 shadow-xl" data-testid="calendar-menu">
          <a href={googleUrl()} target="_blank" rel="noopener noreferrer" onClick={() => setOpen(false)}
            className="block px-5 py-3 text-sm text-matte hover:bg-taupe-light/40 text-left" data-testid="calendar-google">Google Calendar</a>
          <button onClick={() => { downloadIcs(); setOpen(false); }}
            className="block w-full px-5 py-3 text-sm text-matte hover:bg-taupe-light/40 text-left border-t border-taupe/20" data-testid="calendar-ics">Apple / Outlook (.ics)</button>
        </div>
      )}
    </div>
  );
}
